import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

/**
 * Send a friend request to a user by username
 */
export async function sendFriendRequest(toUsername) {
  const fn = httpsCallable(functions, 'sendFriendRequest');
  const result = await fn({ toUsername });
  return result.data;
}

/**
 * Accept an incoming friend request
 */
export async function acceptFriendRequest(requestId) {
  const fn = httpsCallable(functions, 'acceptFriendRequest');
  const result = await fn({ requestId });
  return result.data;
}

/**
 * Reject an incoming friend request
 */
export async function rejectFriendRequest(requestId) {
  const fn = httpsCallable(functions, 'rejectFriendRequest');
  const result = await fn({ requestId });
  return result.data;
}

/**
 * Cancel an outgoing friend request (sender cancels)
 */
export async function cancelFriendRequest(requestId) {
  const fn = httpsCallable(functions, 'cancelFriendRequest');
  const result = await fn({ requestId });
  return result.data;
}

/**
 * Remove an existing friendship
 */
export async function removeFriend(friendshipId) {
  const fn = httpsCallable(functions, 'removeFriend');
  const result = await fn({ friendshipId });
  return result.data;
}
